import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Modal, Button } from 'antd';
const FormItem = Form.Item;
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory'
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { SgiMainComp } from './SgiMainComp'
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { SgiPanel } from '../sgiComp/SgiPanel'
import { getConstByKey } from './sgiBaseComp/SgiCommon';

class SgiNest extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        this.state = {
            formProps: { style: { height: '100%', width: '100%' } },
            loading: false,
            panelItems: []
        };
    }

    /**
     * 根据描述创建文本框
     * @param {弹出页面guid} uid
     * @param {对象工厂} objFct
     * @param {弹出窗标题} curtitle
     */
    nest_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.panelItems = []; //再次渲染的时候清空
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.formProps);
        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.formProps);
        //组装form表单下的控件信息
        if (type !== "dnd") {
            this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
        } else {
            this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, "dnd-nest");
        }
    }


    AddAttribute = function (moduleDesc, formProps) {
        //嵌入UID

    }


    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
        var me = this;

        let uijson = moduleDesc.nestDesc;
        let uid = moduleDesc.uid;

        if (!uijson) {
            if (!uid) {
                // 显示缺省信息
                this.showDefault(panelItems, moduleDesc);
                return;
            }

            uijson = PrmFactory.getPrm(uid);
            if (!uijson) {
                // 显示缺省信息
                this.showDefault(panelItems, moduleDesc);
                return;
            }
            if (!uijson.desId) {
                uijson.desId = "EP_EO_UI_0001";
            }
        }

        if (!objFct) {
            if (!uid) return;

            objFct = new ObjFactory();
            objFct.set('@currentObjFctUID', uid);
        }
        panelItems.push(convertModuleByGuid(this, uijson, null, objFct, type));
    }

    showDefault = (panelItems, moduleDesc) => {
        let showStr = moduleDesc.te || moduleDesc.n || moduleDesc.key || getConstByKey(this, moduleDesc.cId);
        if (!showStr) return;
        let showText = <div>{showStr}</div>;
        panelItems.push(<div style={{
            width: "100%", height: "100%", border: "1px dashed gray",
            display: "flex", justifyContent: "center", alignItems: "center"
        }}>{showText}</div>);
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    refreshByUI = (ui) => {
        if (!ui) return;
        if (typeof ui === "string") this.props.moduleDesc.uid = ui;
        else this.props.moduleDesc.nestDesc = ui;
        this.loaded = false;
        this.setState({});
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        var { objFct } = this.props;

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.nest_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.formProps);

        return (
            <div {...this.state.formProps}>
                {this.state.panelItems}
            </div>
        );
    }
}
//给类添加公共方法
Object.assign(SgiNest.prototype, sgiCtnBaseFun);
export { SgiNest };
export default SgiNest;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiNest.js